import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import Configuracion from '../../components/Configuracion';
import MantenimientoForm from '../../components/common/MantenimientoForm';
import * as configuracionService from "../../services/configuracionService";
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations } from '../../redux/configuracionSlice';

// Mantenimiento de los parametros del sistema (tabla configuracion).
const Edit = () => {
    const configuracion = useSelector((state) => state.configuracion.entity);
    const configuracionValidation = useSelector((state) => state.configuracion.validationMessage);

    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
    const dispatch = useDispatch();
    const params = useParams();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("configuracion");

    const postEntity = async () => {
        if (configuracionValidation.length > 0) {
            dispatch(activeValidations());
            setPropsMessage({ severity: "error", message: configuracionValidation.join(" - ") });
            setOpenMessage(true);
            return;
        }

        try {
            await configuracionService.addUpdateConfiguracion({
                idConfiguracion: configuracion.idConfiguracion,
                codigo: (configuracion.codigo || "").trim(),
                descripcion: (configuracion.descripcion || "").trim(),
                valor: (configuracion.valor || "").trim(),
            });

            setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" });
            setOpenMessage(true);
            setIsReadOnly(true);
        }
        catch (err) {
            console.log("Err: ", err);
            // Si el backend rechazo los datos, el motivo viene en detail.
            setPropsMessage({ severity: "error", message: err.response?.data?.detail || "Hubo un error al guardar" });
            setOpenMessage(true);
        }
    }

    return (
        <div>
            <MantenimientoForm
                title={(parseInt(params.id) === 0 ? "Nuevo" : "Editar") + " Parametro"}
                backTo={"/configuracion"}
                onSave={postEntity}
                disabled={isReadOnly}
            >
                <Grid container spacing={1} sx={{
                    "& .MuiGrid-root>.MuiGrid-item": {
                        paddingTop: "8px"
                    },
                }}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                <Configuracion isReadOnly={isReadOnly} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                    {propsMessage.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Edit
